import { useMemo } from "react";
import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";
import { distances } from "./DistanceFilterData";
import { DistanceFilterOption } from "./DistanceFilterOption";

const DistanceFilter = () => {
	const {
		locationButtonId,
		setLocationString,
		locationQuery,
		distanceQuery,
		distanceButtonId,
		setDistanceButtonId,
		setDistanceString,
		dictionaryWords,
		isLoadingDictionary,
	} = useContext(ActivitiesContext);

	const distanceFilterHandler = (event) => {
		if (event.target.value === "") {
			setDistanceString(event.target.value);
			setDistanceButtonId(event.target.value);
			setLocationString(locationQuery);
		} else if (event.target.value === distanceButtonId) {
			setDistanceString(event.target.value + distanceQuery);
			setDistanceButtonId(event.target.value);
			setLocationString("");
		} else if (event.target.value !== "") {
			setDistanceString(event.target.value + distanceQuery);
			setDistanceButtonId(event.target.value);
			setLocationString("");
		}
	};

	const distanceOptions = useMemo(() => {
		return distances.map((distance) => {
			return (
				<DistanceFilterOption distance={distance} key={distance} />
			);
		})
	},[]);

	return (
		<div className="input-group radius">
			{!isLoadingDictionary && (
				<>
					<label className="c-input__label" htmlFor="radius-select">
						{dictionaryWords.changeRadius}
					</label>
					<select
						className="c-input__field"
						id="radius-select"
						disabled={
							(locationButtonId === "all" && true) ||
							(locationButtonId === "" && true)
						}
						onChange={distanceFilterHandler}
						value={distanceButtonId}
					>
						{distanceOptions}
					</select>
				</>
			)}
		</div>
	);
};

export default DistanceFilter;
